// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecAnalysis_wrapper__34dln"};